import React, { useEffect, useState } from 'react'
import styles from "../../../assets/css/admin/layout.module.css";
import axios from "axios";
import SideBar from "../SideBar";
import { baseUrl } from "../../../baseUrl";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from 'react-router-dom';

const CreateStudent = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [message,setMessage]=useState(false)
    const [name,setName]=useState("")
    const [email,setEmail]=useState("")
    const [contact,setContact]=useState('')
    const [className,setClassName]=useState('')
    const [course, setCourse] = useState(false)
    const [courses,setCourses]=useState([])
    const [payment,setPayment]=useState("")
    const [amount,setAmount]=useState("")
    const [paymentID,setPaymentID]=useState("")
    const [dob,setDOB]=useState('')
    const [gender,setGender]=useState('')
    const [fatherName,setFatherName]=useState('')
    const [motherName,setMotherName]=useState('')
    const [category,setCategory]=useState('')
    const [reference,setReference]=useState('')
    const [password,setPassword]=useState('')
    const [confirmPassword,setConfirmPassword]=useState('')

    const data={name,email,className,contact,course,payment,amount,paymentID,dob,gender,fatherName,motherName,category,reference,password}

    useEffect(() => {
        const timer = setTimeout(() => {
          setMessage(false);
        }, 4000);
        return () => clearTimeout(timer);
      }, [message]);
    const getCourses=()=>{
      axios.get(`${baseUrl}/course/by-class?className=${className}`)
      .then(res=>setCourses(res.data))
      .catch(err=>console.log(err))
  }
      useEffect(()=>{
          getCourses()
          setCourse(false)
      },[className])

      const handleCourse = (e) => {
        const selectedOption = e.target.selectedOptions[0];
        const course = selectedOption ? JSON.parse(e.target.value) : null;
        setCourse(course);  // Update selected course
    };
    const handleClass = (e) => {
        setClassName(e.target.value)
    }
    const handleSubmit=()=>{
      if(password!==confirmPassword){
        setMessage('Please enter Confirm password same as Password')
      }
      else if(name===""||email===""||course===""||payment===''||dob===''||gender===''||fatherName===''||motherName===''||
        category===''||password===''||confirmPassword===''
      ){
        setMessage('Make sure you enter all required details')
      }
      else{
        axios.post(`${baseUrl}/student/register`,data)
        .then(res=>{
          setMessage(res.data.message)
        })
        .catch(err=>{
          err.response?setMessage(err.response.data.message):setMessage('Server error')
        })
      }
    }

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>
      
      <main className={styles.mainContent}>
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/students' className="text-decoration-none">Students</Link>
              </li>
              <li className="breadcrumb-item active">
                Add
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className={`container ${styles.container}`}>
          <div className="bg-white p-4">
            <h4>Student Registration</h4>
            <form onSubmit={handleSubmit}>
            <div className="row mb-3">
              <div className="col-lg-4 col-md-6">
                <label htmlFor="name" className="form-label">
                  Student Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Enter Name"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="col-lg-4 col-md-6">
                <label htmlFor="email" className="form-label">
                    Email
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Enter Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
                <div className="col-lg-4 col-md-6">
                  <label htmlFor="contact" className="form-label">
                    Contact Number
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="contact"
                    placeholder="Enter contact number"
                    onChange={(e) => setContact(e.target.value)}
                  />
                </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="class" className="form-label">
                  Class
                </label>
                <select onChange={handleClass} className="form-select" id="class" aria-label="Default select example">
                  <option hidden>Select Class</option>
                    <option>
                        Class XI
                    </option>
                    <option>
                        Class XII
                    </option>
                    <option>
                        Class XII Passed
                    </option>
                </select>
              </div>
                <div className="col-lg-6">
                  <label htmlFor="course" className="form-label">
                    Course
                  </label>
                  {
                    courses.length < 1 ?
                      <p>No course available</p>
                      :
                      <select
                        onChange={handleCourse}
                        className="form-select"
                        id="course"
                        aria-label="Select Course"
                        value={course ? JSON.stringify(course) : ''}  // Control value of select
                      >
                        <option hidden>Select Course</option>
                        {
                          courses.map((c, i) =>
                            <option key={i} value={JSON.stringify(c)}>
                              {c.title}
                            </option>
                          )
                        }
                      </select>
                  }
                </div>
              </div>
            <div className="row mb-4">
              <div className="col-lg-3 col-md-6">
                <label htmlFor="payment" className="form-label">
                  Payment Mode
                </label>
                <select onChange={(e)=>setPayment(e.target.value)} className="form-select" id="payment" aria-label="Default select example">
                  <option hidden>Select Payment Mode</option>
                    <option value='Cash'>
                        Cash
                    </option>
                    <option value='online'>
                        Online
                    </option>
                </select>
              </div>
              <div className="col-lg-4 col-md-6">
                <label htmlFor="paymentID" className="form-label">
                    Payment ID
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="paymentID"
                  placeholder="Enter payment ID"
                  onChange={(e) => setPaymentID(e.target.value)}
                />
              </div>
              <div className="col-lg-4 col-md-6">
                <label htmlFor="amount" className="form-label">
                    Amount
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="amount"
                  placeholder="Enter amount paid"
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="dob" className="form-label">
                  Date of Birth
                </label>
                <input id='dob' type='date' className="form-control" onChange={(e)=>setDOB(e.target.value)}/>
              </div>
              <div className="col-lg-6">
                <label htmlFor="gender" className="form-label">
                    Gender
                </label>
                <select onChange={(e)=>setGender(e.target.value)} className="form-select" id="gender" aria-label="Default select example">
                  <option hidden>Select Gender</option>
                    <option value='male'>
                        Male
                    </option>
                    <option value='female'>
                        Female
                    </option>
                    <option value='other'>
                        Other
                    </option>
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="fatherName" className="form-label">
                  Father Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="fatherName"
                  placeholder="Enter Father Name"
                  onChange={(e) => setFatherName(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="motherName" className="form-label">
                    Mother Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="motherName"
                  placeholder="Enter Mother name"
                  onChange={(e) => setMotherName(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="category" className="form-label">
                  Category
                </label>
                <select onChange={(e)=>setCategory(e.target.value)} className="form-select" id="category" aria-label="Default select example">
                  <option hidden>Select category</option>
                    <option>
                        General
                    </option>
                    <option>
                        OBC
                    </option>
                    <option>
                        SC
                    </option>
                    <option>
                        ST
                    </option>
                </select>
              </div>
              <div className="col-lg-6">
                <label htmlFor="reference" className="form-label">
                    Reference
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="reference"
                  placeholder="Enter reference (optional)"
                  onChange={(e) => setReference(e.target.value)}
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-lg-6">
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="password"
                  placeholder="Enter password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="confirmPassword" className="form-label">
                  Confirm Password
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  placeholder="Reenter password"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>
            </div>
            </form>
            {message && (
              <div
                className="alert alert-warning alert-dismissible fade show mt-3"
                role="alert"
              >
                {message}
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                  onClick={() => setMessage(false)}
                ></button>
              </div>
            )}
            <button onClick={handleSubmit} className="btn btn-primary mt-4">
              Register
            </button>
          </div>
        </div>
      </main>
    </div>
  )
}

export default CreateStudent
